import request from '@/utils/request'

let QueuerebateApi = {
    /*列表*/
    getProduct(data) {
        return request._get('/shop/plus.queuerebate.product/index', data);
    },
    /*添加*/
    addProduct(data) {
        return request._post('/shop/plus.queuerebate.product/add', data);
    },
    /*编辑*/
    editProduct(data) {
        return request._post('/shop/plus.queuerebate.product/edit', data);
    },
    /*删除*/
    delProduct(data) {
        return request._post('/shop/plus.queuerebate.product/delete', data);
    },
    /*获取设置*/
    getSetting(data) {
        return request._get('/shop/plus.queuerebate.setting/index', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.queuerebate.setting/index', data);
    },
    orderlist(data) {
        return request._get('/shop/plus.queuerebate.order/index', data);
    },

}

export default QueuerebateApi;



// WEBPACK FOOTER //
// ./src/api/queuerebate.js